import {
  faCheck,
  faCircleStop,
  faClipboardCheck,
  faClipboardList,
  faClock,
  faCoins,
  faEye,
  faHandHoldingDollar,
  faPause,
  faPenRuler,
  faPlay,
  faQuestion,
  faSackXmark,
  faSquareXmark,
  faStop,
  faTags,
  faUserCheck,
  faUserTag,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import {
  InternalLedgerSessionStatus,
  OfferStatus,
} from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { type MaybeRef } from 'vue';
import { useBadgeInfoObject } from '../style/useBadgeInfoObject';
import { type DisplayBadgeType } from '../style/useDisplayBadgeClass';

export const useInternalLedgerSessionStatusInfo = (
  colorType: MaybeRef<DisplayBadgeType> = 'badge',
  status?: MaybeRef<InternalLedgerSessionStatus>,
) => {
  const {
    badgeInfo,
    getBadgeClass,
    getBadgeColor,
    getBadgeIcon,
    getBadgeTitle,
    getBadgeInfo,
  } = useBadgeInfoObject<InternalLedgerSessionStatus>(
    {
      i18nPrefix: 'internal-ledger.session-status',
      colorMap: {
        [InternalLedgerSessionStatus.COUNTING_CLOSED]: 'warning',
        [InternalLedgerSessionStatus.COUNTING_OPEN]: 'warning',
        [InternalLedgerSessionStatus.OPEN]: 'primary',
        [InternalLedgerSessionStatus.CLOSED]: 'neutral',
      },
      iconMap: {
        [InternalLedgerSessionStatus.COUNTING_CLOSED]: faCoins,
        [InternalLedgerSessionStatus.COUNTING_OPEN]: faCoins,
        [InternalLedgerSessionStatus.OPEN]: faPlay,
        [InternalLedgerSessionStatus.CLOSED]: faStop,
      },
      defaultColor: 'neutral',
      defaultIcon: faQuestion,
    },
    colorType,
    status,
  );

  return {
    internalLedgerSessionStatusInfo: badgeInfo,
    getStatusTitle: getBadgeTitle,
    getStatusClass: getBadgeClass,
    getStatusColor: getBadgeColor,
    getStatusIcon: getBadgeIcon,
    getStatusInfo: getBadgeInfo,
  };
};
